<template>
  <BaseModal
    :is-visible="isVisible"
    :is-archivable="false"
    :is-editable="false"
    @hideModal="hideModal()"
    size="lg"
  >
    <template #header>
      {{$t('routes.EXSBPriceUserDataCreate')}}
    </template>
    <template #body>
      <Create></Create>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import Create from '@/components/Dashboard/Views/BusinessBundle/exsbpriceuserdata/Create'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CreateModal',
  components: {
    BaseModal,
    Create
  },
  computed: {
    ...mapGetters({
      isVisible: 'exsbpriceuserdata/createModal/isVisible'
    })
  },
  methods: {
    hideModal () {
      this.toggleModal()
    },
    ...mapMutations({
      toggleModal: 'exsbpriceuserdata/createModal/toggleModal'
    })
  }
}
</script>

<style scoped>

</style>
